import * as React from 'react';

import * as styles from './styles.css';
import cn from 'clsx';
import { UIText1, UIText2, useDeviceType } from '@cian/ui-kit';
import { IconProductGift16 } from '@cian/ui-kit-design-tokens/icons';

interface IGarantLabelProps {
  isLabel?: boolean;
}

export const GarantLabel: React.FC<IGarantLabelProps> = ({ isLabel }) => {
  const device = useDeviceType();
  const isDesktop = device === 'desktop';

  return (
    <div className={cn(styles['container'], isLabel && styles['label-container'])}>
      <div className={styles['title']}>
        <IconProductGift16 color="accent-positive-primary" />
        {isDesktop && !isLabel ? (
          <UIText1 color="text-primary-default">
            Защита от потери права собственности с компенсацией до 50 млн ₽, если покупаете с нами
          </UIText1>
        ) : (
          <UIText2 color="text-primary-default">
            Защита от потери права собственности с компенсацией до 50 млн ₽, если покупаете с нами
          </UIText2>
        )}
      </div>
    </div>
  );
};
